import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-foreground-50">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <h4 className="font-heading text-lg font-bold mb-4">
                <Link to="/" className="hover:text-primary-400 transition-colors">汗汗漫画</Link>
              </h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                汗汗漫画是专业的免费韩国漫画在线阅读平台，提供海量优质韩漫资源，更新及时，访问流畅，是您休闲时光的可靠伴侣。
              </p>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">快速导航</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">网站首页</Link>
                </li>
                <li>
                  <Link to="/category/all" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">漫画分类</Link>
                </li>
                <li>
                  <Link to="/category/romance" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">恋爱漫画</Link>
                </li>
                <li>
                  <Link to="/category/action" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">热血漫画</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">热门推荐</h4>
              <ul className="flex flex-col gap-2">
                <li>
                  <Link to="/manga/manga-2" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">我独自升级</Link>
                </li>
                <li>
                  <Link to="/manga/manga-7" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">全知读者视角</Link>
                </li>
                <li>
                  <Link to="/manga/manga-1" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">女神降临</Link>
                </li>
                <li>
                  <Link to="/manga/manga-12" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap">神之塔</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-heading text-base font-semibold mb-4">联系我们</h4>
              <ul className="flex flex-col gap-2 text-sm text-foreground-300">
                <li>
                  <i className="ri-mail-line mr-2"></i>
                  contact@hanhanmanga.com
                </li>
                <li>
                  <i className="ri-customer-service-line mr-2"></i>
                  在线客服：工作日 9:00-18:00
                </li>
                <li>
                  <i className="ri-map-pin-line mr-2"></i>
                  中国·上海
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-700/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} 汗汗漫画 - 免费韩国漫画在线阅读平台。本站所有漫画均来自互联网，版权归原作者所有。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">隐私政策</a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">服务条款</a>
              <a href="#" className="text-foreground-400 hover:text-primary-400 transition-colors text-xs whitespace-nowrap" rel="nofollow">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}